import { ADD_NOTIFICATION } from '../actions/types';

const position = 'bottom-right';

const notification = (title, message, err, modal, callback, testId) => {
	if (err) {
		if (modal) {
			return {
				type: ADD_NOTIFICATION,
				payload: {
					title,
					message,
					position,
					action: {
						label: 'Send again',
						callback,
					},
					severity: 'error',
					testId,
				},
			};
		}
		return {
			type: ADD_NOTIFICATION,
			payload: { title, message, position, severity: 'error', testId },
		};
	}

	return {
		type: ADD_NOTIFICATION,
		payload: { title, message, position, severity: 'success', testId },
	};
};

export default notification;
